/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Grid,
  FormControlLabel,
  Checkbox,
  TextField,
  Box,
} from '@material-ui/core';
import type { Control } from 'react-hook-form/dist/types';
import { Controller } from 'react-hook-form';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { startOfToday, setHours } from 'date-fns';

import ReactHookFormTextField from '../global/forms/ReactHookFormTextField';
import type {
  AdditionalField,
} from './MarkingInterfaces';

interface IAdditionalFieldProps {
  additionalProp: AdditionalField;
  reactHookControl: Control;
}

const MarkingAdditionalField: React.FC<IAdditionalFieldProps> = ({ additionalProp, reactHookControl }) => {
  if (additionalProp.fieldType === 'DateTime') {
    return (
      <Grid item xs={6}>
        <Controller
          name={`additionalProperties.${additionalProp.fieldName}`}
          defaultValue={setHours(Date.parse(additionalProp.fieldValue), 0)}
          rules={{
            required: {
              value: true,
              message: `${additionalProp.fieldName} is required`,
            },
          }}
          render={({ field: { ref, ...rest }, fieldState, formState }) => (
            <KeyboardDatePicker
              autoOk
              disableToolbar
              id="date-picker-dialog"
              format="MM/dd/yyyy"
              initialFocusedDate={setHours(Date.parse(additionalProp.fieldValue), 0) || startOfToday()}
              KeyboardButtonProps={{
                'aria-label': 'Change date',
              }}
              invalidDateMessage={`${additionalProp.fieldName} is required`}
              {...rest}
              TextFieldComponent={(params) => (
                <TextField
                  {...params}
                  required
                  fullWidth
                  label={additionalProp.fieldName}
                  variant="outlined"
                  error={!!fieldState.error || (formState.isSubmitted && !fieldState.isDirty && !additionalProp.fieldValue) || params.error}
                  helperText={fieldState?.error?.message || params.helperText || ' '}
                />
              )}
            />
          )}
          control={reactHookControl}
        />
      </Grid>
    );
  }

  if (additionalProp.fieldType === 'bool') {
    return (
      <Grid item xs={6}>
        <Box pl={1} pt={0.5}>
          <FormControlLabel
            control={(
              <Controller
                name={`additionalProperties.${additionalProp.fieldName}`}
                control={reactHookControl}
                defaultValue={Boolean(JSON.parse(additionalProp.fieldValue))}
                render={(props) => (
                  <Checkbox
                    {...props}
                    checked={Boolean(props.field.value)}
                    onChange={(e) => props.field.onChange(e.target.checked)}
                  />
                )}
              />
          )}
            label={additionalProp.fieldName}
          />
        </Box>
      </Grid>
    );
  }
  return (
    <Grid item xs={6}>
      <ReactHookFormTextField
        label={additionalProp.fieldName}
        name={`additionalProperties.${additionalProp.fieldName}`}
        control={reactHookControl}
        defaultValue={additionalProp.fieldValue}
        type={additionalProp.fieldType === 'double' ? 'number' : undefined}
        required
      />
    </Grid>
  );
};

export default MarkingAdditionalField;
